function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createContext, useContext, useMemo } from 'react';
import { getMockEventTargets } from "./event-targets/useEventTargets";
import { ignoreError } from "../infra/utils";
import { BusinessPartyTypeEnum } from "../store/store.model";
import { jsx as _jsx } from "react/jsx-runtime";
const useInternalEventReporter = () => useContext(EventReporterContext);
export function useEventReporter() {
  const {
    gtm,
    appcues,
    heap,
    hubspot
  } = useInternalEventReporter();
  return useMemo(() => {
    const sendEvent = (category, action, label, additionalData) => {
      ignoreError(() => {
        const eventData = _objectSpread(_objectSpread({}, additionalData), {}, {
          event_category: category,
          event_action: action,
          event_label: label
        });
        const eventName = "".concat(category, "-").concat(action, "-").concat(label);
        gtm.sendEventDeprecated(eventName, eventData);
        heap.sendEventDeprecated(eventName, eventData);
        appcues.sendEventDeprecated(eventName, eventData);
      });
    };
    return {
      reportToGtm: gtm.report,
      sendEventToGtm: gtm.sendEvent,
      reportToHeap: heap.report,
      reportToAppcues: appcues.report,
      reportToHubspot: hubspot.report,
      heapResetIdentity() {
        heap.resetIdentity();
      },
      heapIdentify(userId, userEmail, userProperties) {
        heap.identify(userId, userEmail, userProperties);
      },
      appcuesIdentify(userId, userEmail, userProperties) {
        appcues.identify(userId, userEmail, userProperties);
      },
      /** @deprecated */
      reportButtonClick(buttonName) {
        return sendEvent('button', 'click', buttonName);
      },
      /** @deprecated */
      reportOpenNotification(notificationType) {
        return sendEvent('notification', 'open', notificationType);
      },
      /** @deprecated */
      reportPopupAction(popupTitle) {
        let isOpen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return sendEvent('popup', isOpen ? 'open' : 'close', popupTitle);
      },
      /** @deprecated */
      prepareFormObject(field_name, value) {
        return {
          field_name,
          value
        };
      },
      reportPageView(pathname, pageTitle, worksAt) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const eventData = {
          page_url: pathname,
          page_title: pageTitle
        };
        if (worksAt != null) {
          const isVendor = worksAt.type === BusinessPartyTypeEnum.Vendor;
          eventData.vendor_id = isVendor ? worksAt.id : null;
          eventData.user_type = isVendor ? 'vendor' : 'customer';
        }
        gtm.sendPageView({
          page_location: window.location.origin + pathname,
          page_title: pageTitle
        });
        hubspot.sendPageView(pathname, eventData);
        appcues.sendPageView(pathname, eventData);
      },
      /** @deprecated
       * Migration example
       *
       * Before:
       * reportFormSubmission('user-successfully-sent-first-agreement', null);
       *
       * After:
       * reportToGtm('form-success', 'user-successfully-sent-first-agreement');
       * reportToAppcues('form-success', 'user-successfully-sent-first-agreement');
       * reportToHubspot('user_successfully_sent_first_agreement_');
       * reportToHeap('agreementStudio', 'submit', 'user-successfully-sent-first-agreement');
       */
      reportFormSubmission(formName, formData) {
        return sendEvent('form', 'success', formName, {
          form: formData || {}
        });
      },
      /** @deprecated */
      reportProductsFormSubmission(formName, productsArr) {
        return sendEvent('form', 'success', formName, {
          products: productsArr || []
        });
      }
    };
  }, []);
}
const EventReporterContext = /*#__PURE__*/createContext(getMockEventTargets());
export function EventReporterProvider(_ref) {
  let {
    children,
    eventTargets
  } = _ref;
  return /*#__PURE__*/_jsx(EventReporterContext.Provider, {
    value: eventTargets,
    children: children
  });
}